import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/global.css';

import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { hasAnyPermission } from '@/utils/permission';

Vue.config.productionTip = false;
Vue.use(ElementUI);

function applyPermission(el, binding, vnode) {
  const allowed = hasAnyPermission(vnode && vnode.context, binding ? binding.value : null);
  if (el.__originDisplay === undefined) {
    el.__originDisplay = el.style.display || '';
  }
  el.style.display = allowed ? el.__originDisplay : 'none';
}

function bindPermissionWatchers(el, binding, vnode) {
  const root = vnode.context && vnode.context.$root;
  if (!root || el.__hasPermiUnwatch) {
    return;
  }
  const run = () => applyPermission(el, binding, vnode);
  const un1 = root.$watch('currentUser', run, { deep: true });
  const un2 = root.$watch('menuTree', run, { deep: true });
  el.__hasPermiUnwatch = () => {
    un1();
    un2();
  };
}

// 权限指令 v-hasPermi — 基于当前用户菜单权限隐藏按钮（监听 currentUser.grantedPerms / menuTree 避免异步竞态）
Vue.directive('hasPermi', {
  inserted(el, binding, vnode) {
    applyPermission(el, binding, vnode);
    bindPermissionWatchers(el, binding, vnode);
  },
  componentUpdated(el, binding, vnode) {
    applyPermission(el, binding, vnode);
  },
  update(el, binding, vnode) {
    applyPermission(el, binding, vnode);
  },
  unbind(el) {
    if (el.__hasPermiUnwatch) {
      el.__hasPermiUnwatch();
      el.__hasPermiUnwatch = null;
    }
  },
});

Vue.directive('el-drag-dialog', {
  bind(el) {
    var header = el.querySelector('.el-dialog__header');
    var dialog = el.querySelector('.el-dialog');
    if (!header || !dialog) return;
    header.style.cursor = 'move';
    header.onmousedown = function(e) {
      var disX = e.clientX - dialog.offsetLeft;
      var disY = e.clientY - dialog.offsetTop;
      document.onmousemove = function(e) {
        dialog.style.marginLeft = '0';
        dialog.style.marginTop = '0';
        dialog.style.left = (e.clientX - disX) + 'px';
        dialog.style.top = (e.clientY - disY) + 'px';
      };
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app');

